(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nf-bundle-cards"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('nf-bundle-cards')) return;

    /** Remembers the chosen card per product while the section re-renders on variant change. */
    const chosen = new Map();

    class NfBundleCards extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        const saved = chosen.get(this.dataset.productId);
        if (saved) {
          const input = this.querySelector(`.nf-bundle__input[data-option="${saved}"]`);
          if (input) input.checked = true;
        }
        this.addEventListener('change', () => this.sync(true), { signal });
        // Re-apply just before the theme's form submits, in case its quantity input was re-rendered.
        document.addEventListener('submit', (event) => {
          if (event.target instanceof HTMLFormElement && this.form() === event.target) this.sync(false);
        }, { capture: true, signal });
        this.sync(false);
      }

      disconnectedCallback() {
        this.abort?.abort();
      }

      /** @returns {HTMLFormElement | null} the add-to-cart form in the same section */
      form() {
        const section = this.closest('.shopify-section');
        return section ? section.querySelector('form[data-type="add-to-cart-form"]') : null;
      }

      /** @param {boolean} remember */
      sync(remember) {
        const checked = /** @type {HTMLInputElement | null} */ (this.querySelector('.nf-bundle__input:checked'));
        if (!checked) return;
        if (remember) chosen.set(this.dataset.productId, checked.dataset.option);
        const form = this.form();
        const qty = form ? form.querySelector('input[name="quantity"]') : null;
        if (!(qty instanceof HTMLInputElement)) return;
        qty.value = checked.value;
        qty.dispatchEvent(new Event('input', { bubbles: true }));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    customElements.define('nf-bundle-cards', NfBundleCards);
  })();
  } catch(e) { console.error(e); }
})();

})();
